import React from 'react'

import { useStackBack } from './useStackBack'
import { NavigationStackEntry } from './navigationStack'

interface Props {
  fallback: NavigationStackEntry
}

export function EventDetailsBack({ fallback }: Props) {
  const { label, goBack } = useStackBack(fallback)

  return (
    <div className="event_details_back">
      <div className="event_details_back_block" onClick={goBack}>
        <img src={'/assets/images/back_arrow.svg'} alt="back" className="event_details_back_icon" />
        Back to {label}
      </div>
    </div>
  )
}
